import React, { useEffect } from "react";
import {
  createOppInvoiceMerchants,
  createWefactMasterInvoices,
  getOppInvoiceMerchants,
  getOppMasterMerchants,
  getOppMerchants,
} from "../PaymentProviders/Opp/OppApi";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid, IconButton, Menu, MenuItem, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { addWeeks, endOfISOWeek, format, getISOWeek, getYear, startOfISOWeek, subWeeks } from "date-fns";
import { ArrowLeft, ArrowRight, Build } from "@material-ui/icons";
import OppInvoiceMerchant from "./OppInvoiceMerchant";

function OppInvoicesMasterMerchant(props) {
  const oppMasterMerchantId = parseInt(props.match.params.oppMasterMerchantId);

  const [oppMasterMerchant, setOppMasterMerchant] = React.useState(props.location?.state?.oppMasterMerchant);
  const [oppInvoiceMerchants, setOppInvoiceMerchants] = React.useState(null);
  const [oppInvoiceMerchantsChecked, setOppInvoiceMerchantsChecked] = React.useState({});
  const [oppMerchants, setOppMerchants] = React.useState(null);

  const now = new Date();
  const [period, setPeriod] = React.useState(now);
  const firstDayPeriod = startOfISOWeek(period);
  const lastDayPeriod = endOfISOWeek(period);

  const [loadingOppInvoiceMerchants, setLoadingOppInvoiceMerchants] = React.useState(true);
  const [anchorMenu, setAnchorMenu] = React.useState(null);

  useEffect(() => {
    if (oppMasterMerchant == null) {
      getOppMasterMerchants().then((oppMasterMerchants) => {
        oppMasterMerchants.some((oppMasterMerchant) => {
          if (oppMasterMerchant.id === oppMasterMerchantId) {
            setOppMasterMerchant(oppMasterMerchant);
            return true;
          }
          return false;
        });
      });
    }
  }, []);

  useEffect(() => {
    if (oppMasterMerchant) {
      getOppMerchants(oppMasterMerchant.id).then((oppMerchants) => {
        setOppMerchants(oppMerchants); //.splice(0, 5));
      });
    }
  }, [oppMasterMerchant]);

  useEffect(() => {
    if (oppMerchants) {
      setOppInvoiceMerchantsChecked({});
      getOppInvoiceMerchants(oppMasterMerchantId, 1).then((oppInvoiceMerchants) =>
        setOppInvoiceMerchants(oppInvoiceMerchants)
      );
    }
  }, [period, oppMerchants]);

  useEffect(() => {
    if (oppMerchants && oppInvoiceMerchants && loadingOppInvoiceMerchants) {
      const missingOppInvoiceMerchantsOfOppMerchants = [];

      oppMerchants.forEach((oppMerchant) => {
        const oppInvoiceMerchant = oppInvoiceMerchants?.find(
          (oppInvoiceMerchant) => oppInvoiceMerchant.ext_merchant_key === oppMerchant.uid
        );
        if (oppInvoiceMerchant == null) {
          missingOppInvoiceMerchantsOfOppMerchants.push(oppMerchant);
        }
      });

      createOppInvoiceMerchants(
        oppMasterMerchantId,
        missingOppInvoiceMerchantsOfOppMerchants.map((oppMerchant) => {
          return { ext_merchant_key: oppMerchant.uid, coc_nr: oppMerchant.coc_nr, name: oppMerchant.name };
        })
      ).then((newOppInvoiceMerchants) => {
        setLoadingOppInvoiceMerchants(false);
        console.log(newOppInvoiceMerchants);
      });
    }
  }, [oppMerchants, oppInvoiceMerchants]);

  if (oppMasterMerchant == null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div>
      <Typography variant={"h6"}>{oppMasterMerchant.name}</Typography>
      <div style={{ display: "flex", alignItems: "center" }}>
        <IconButton
          onClick={() => {
            setPeriod(subWeeks(period, 1));
          }}
        >
          <ArrowLeft />
        </IconButton>
        <Typography variant={"h6"}>
          {getYear(period)} Week {getISOWeek(period)}: {format(firstDayPeriod, "MMM dd")} -{" "}
          {format(lastDayPeriod, "MMM dd")}
        </Typography>
        <IconButton
          onClick={() => {
            setPeriod(addWeeks(period, 1));
          }}
        >
          <ArrowRight />
        </IconButton>
      </div>

      <Grid container spacing={3} key={period.getTime()} alignItems={"center"}>
        <Grid item xs={3}>
          <Typography variant={"subtitle1"}>Klant</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant={"subtitle1"}># transacties</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant={"subtitle1"}>Uitbetaling</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant={"subtitle1"}>Te factureren</Typography>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            onClick={(e) => {
              setAnchorMenu(e.currentTarget);
            }}
          >
            <Build />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorMenu}
            open={Boolean(anchorMenu)}
            onClose={() => {
              setAnchorMenu(null);
            }}
          >
            <MenuItem
              disabled={now.getTime() < lastDayPeriod.getTime()}
              onClick={() => {
                setAnchorMenu(null);
                let oppInvoiceMerchantIds = Object.keys(oppInvoiceMerchantsChecked).map((merchantUid) => {
                  if (!oppInvoiceMerchantsChecked[merchantUid]) {
                    return null;
                  }
                  let index = oppInvoiceMerchants.findIndex((oppInvoiceMerchant) => {
                    return oppInvoiceMerchant.ext_merchant_key === merchantUid;
                  });
                  if (index > -1) {
                    return oppInvoiceMerchants[index].id;
                  }
                });
                createWefactMasterInvoices(
                  oppMasterMerchantId,
                  oppInvoiceMerchantIds.filter((id) => id > 0),
                  lastDayPeriod.getTime()
                );
              }}
            >
              CREATE INVOICES
            </MenuItem>
            <MenuItem
              onClick={() => {
                let newChecked = { ...oppInvoiceMerchantsChecked };
                oppMerchants.forEach((oppMerchant) => {
                  newChecked[oppMerchant.uid] = true;
                });
                setOppInvoiceMerchantsChecked(newChecked);
                setAnchorMenu(null);
              }}
            >
              SELECT ALL
            </MenuItem>
            <MenuItem
              onClick={() => {
                let newChecked = { ...oppInvoiceMerchantsChecked };
                oppMerchants.forEach((oppMerchant) => {
                  newChecked[oppMerchant.uid] = false;
                });
                setOppInvoiceMerchantsChecked(newChecked);
                setAnchorMenu(null);
              }}
            >
              DESELECT ALL
            </MenuItem>
          </Menu>
        </Grid>

        {oppMerchants?.map((oppMerchant) => {
          const oppInvoiceMerchant = oppInvoiceMerchants?.find(
            (oppInvoiceMerchant) => oppInvoiceMerchant.ext_merchant_key === oppMerchant.uid
          );
          return (
            <OppInvoiceMerchant
              key={String(oppMerchant.uid)}
              oppMerchant={oppMerchant}
              oppInvoiceMerchant={oppInvoiceMerchant}
              loadingOppInvoiceMerchants={loadingOppInvoiceMerchants}
              period={lastDayPeriod}
              checked={oppInvoiceMerchantsChecked[oppMerchant.uid]}
              setChecked={(checked) => {
                let newChecked = { ...oppInvoiceMerchantsChecked };
                newChecked[oppMerchant.uid] = checked;
                setOppInvoiceMerchantsChecked(newChecked);
              }}
            />
          );
        })}
      </Grid>
    </div>
  );
}

OppInvoicesMasterMerchant.propTypes = {};

export default withRouter(OppInvoicesMasterMerchant);
